var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Normal16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1C4.13404 1 1 4.1339 1 8C1 11.8661 4.13404 15 8 15C11.866 15 15 11.8661 15 8C15 4.1339 11.866 1 8 1ZM8 2.4C11.0928 2.4 13.6 4.9074 13.6 8C13.6 11.0926 11.0928 13.6 8 13.6C4.90719 13.6 2.4 11.0926 2.4 8C2.4 4.9074 4.90719 2.4 8 2.4ZM8 4.5C7.61339 4.5 7.3 4.8136 7.3 5.2C7.3 5.5864 7.61339 5.9 8 5.9C8.38661 5.9 8.7 5.5864 8.7 5.2C8.7 4.8136 8.38661 4.5 8 4.5ZM8 6.6C7.61339 6.6 7.3 6.9136 7.3 7.3V10.8C7.3 11.1864 7.61339 11.5 8 11.5C8.38661 11.5 8.7 11.1864 8.7 10.8V7.3C8.7 6.9136 8.38661 6.6 8 6.6Z"
  }))));
};
export default SvgInfoCircle;